export default __webpack_public_path__ + "static/media/fries.17943956.png";